import { BookingModeProvider } from '@/modules/schedule/booking-mode';
import { AppointmentDialog } from '@/modules/schedule/components/appointment-dialog';

interface BookingModalProps {
  slug: string;
  unitId: string;
  unitName: string;
  /** Veio do link do WhatsApp: abre no que o salao ja lancou. */
  appointmentId?: string;
  onClose: () => void;
}

/**
 * Agendamento da pagina publica: e a **mesma** modal da area logada. Nada e
 * reescrito aqui - o `BookingModeProvider` so troca a origem dos dados (rotas
 * `/public/*`) e faz o primeiro passo pedir o WhatsApp em vez da busca.
 */
export function BookingModal({
  slug,
  unitId,
  unitName,
  appointmentId,
  onClose,
}: BookingModalProps) {
  return (
    <BookingModeProvider slug={slug}>
      <AppointmentDialog id={appointmentId} unitId={unitId} unitName={unitName} onClose={onClose} />
    </BookingModeProvider>
  );
}
